export const aboutData = {
  title: '关于爆料专区',
  subtitle: '全网独家免费吃瓜基地',
  intro: '爆料专区成立于2024年，是国内领先的娱乐资讯聚合平台。我们致力于为"吃瓜群众"提供最新、最快、最全的网红黑料、明星八卦、社会热点与娱乐圈内幕资讯。',
  mission: '在这个信息爆炸的时代，真相往往被淹没在海量的碎片化内容之中。爆料专区的使命，就是帮每一位吃瓜群众拨开迷雾，用最犀利的视角、最真实的内容，还原事件的本来面目。',
  stats: [
    { value: '500万+', label: '月活跃吃瓜群众' },
    { value: '127条', label: '日均爆料更新' },
    { value: '50+', label: '独家爆料记者' },
    { value: '99.7%', label: '内容真实率' },
  ],
  values: [
    {
      title: '真实第一',
      description: '每一条爆料均经过多方信源交叉验证，拒绝谣言和虚假信息。我们坚信，真实的瓜才最甜。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '速度至上',
      description: '建立24小时全天候信息监控网络，热点事件发生后15分钟内即可完成内容发布。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '独立客观',
      description: '不接受任何形式的"公关费"或"删稿费"，保持编辑独立性，为吃瓜群众还原最真实的内幕。',
      icon: 'ri-scales-line',
    },
    {
      title: '用户共创',
      description: '爆料专区鼓励用户投稿和线索提供，每一位吃瓜群众都可以成为内容的创造者和传播者。',
      icon: 'ri-user-heart-line',
    },
  ],
  team: [
    {
      name: '吃瓜老李',
      role: '创始人 / 总编辑',
      description: '前主流媒体调查记者，深耕娱乐行业15年，人脉遍布娱乐圈每个角落。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20aged%20Chinese%20man%20portrait%2C%20editorial%20style%2C%20serious%20expression%2C%20dark%20suit%2C%20studio%20lighting%2C%20clean%20background&width=120&height=120&seq=about-avatar-01&orientation=squarish',
    },
    {
      name: '八卦小王子',
      role: '首席八卦记者',
      description: '娱乐圈活字典，任何明星的行程、关系、八卦，问他准没错。自称"吃瓜界的福尔摩斯"。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20stylish%20Chinese%20man%20with%20glasses%20portrait%2C%20trendy%20outfit%2C%20confident%20smile%2C%20studio%20lighting%2C%20clean%20background&width=120&height=120&seq=about-avatar-02&orientation=squarish',
    },
    {
      name: '瓜田守望者',
      role: '网红线首席记者',
      description: '前MCN机构运营总监，掌握大量网红行业一手内幕。对直播翻车、虚假人设有着敏锐嗅觉。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20sharp%20eyes%2C%20modern%20style%2C%20confident%20expression%2C%20studio%20lighting%2C%20clean%20background&width=120&height=120&seq=about-avatar-03&orientation=squarish',
    },
    {
      name: '真相挖掘机',
      role: '社会热点主编',
      description: '资深调查记者出身，擅长从海量信息中挖掘出被掩盖的真相。曾主导多起轰动全国的重磅报道。',
      avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%2C%20serious%20expression%2C%20experienced%20journalist%20vibe%2C%20studio%20lighting%2C%20clean%20background&width=120&height=120&seq=about-avatar-04&orientation=squarish',
    },
  ],
  timeline: [
    { year: '2024.03', event: '爆料专区正式上线，首日即获得10万用户关注' },
    { year: '2024.06', event: '独家曝光某顶流主播税务问题，全网阅读量突破5000万' },
    { year: '2024.09', event: '月活跃用户突破100万，成为国内最大的独立娱乐资讯平台' },
    { year: '2024.12', event: '上线实时追踪功能，实现热点事件15分钟极速响应' },
    { year: '2025.03', event: '推出四大专区分类，精准覆盖网红、明星、社会、娱乐圈' },
    { year: '2025.06', event: '月活跃用户突破500万，启动投稿爆料功能，实现用户共创' },
  ],
};